// *****小店模块*****
export default [
  {
    path: "/smallShop/home", // 小店首页 - 商品管理和库存管理
    name: "SmallShopHome",
    meta: {
      navBarFlag: false,
      tabBarFlag: true,
      requiredAuth: true,
    },
    component: () => import("@pages/smallShop/home"),
  },
  {
    path: "/smallShop/order", // 小店订单页面
    name: "SmallShopOrder",
    meta: {
      navBarFlag: false,
      tabBarFlag: true,
      requiredAuth: true,
      title: "订单管理 - 小炮庄",
    },
    component: () => import("@pages/smallShop/order"),
  },
  {
    path: "/smallShop/mine", // 小店我的页面
    name: "SmallShopMine",
    meta: {
      navBarFlag: false,
      tabBarFlag: true,
      requiredAuth: true,
      title: "我的 - 小炮庄",
    },
    component: () => import("@pages/smallShop/mine"),
  },
  {
    path: "/smallShop/pubilshPro", // 小店产品发布页面
    name: "SmallShopPubilshPro",
    meta: {
      navBarFlag: false,
      requiredAuth: true,
      title: "产品发布 - 小炮庄",
    },
    component: () => import("@pages/smallShop/pubilshPro"),
    props: true,
  },
  {
    path: "/smallShop/lookVedio", // 小店看视频页面
    name: "SmallShopLookVedio",
    meta: {
      navBarFlag: false,
      requiredAuth: false,
      title: "看视频 - 小炮庄",
    },
    component: () => import("@pages/smallShop/lookVedio"),
  },
  {
    path: "/smallShop/loginHome", // 小店登录首页
    name: "SmallShopLoginHome",
    meta: {
      navBarFlag: false,
      requiredAuth: false,
      title: "登录首页",
    },
    component: () => import("@pages/smallShop/loginHome"),
  },
  {
    path: "/smallShop/pwdLogin", // 小店密码登录
    name: "SmallShopPwdLogin",
    meta: {
      navBarFlag: false,
      requiredAuth: false,
      title: "密码登录",
    },
    component: () => import("@pages/smallShop/pwdLogin"),
  },
  {
    path: "/smallShop/verifyLoginSmallShop", // 小店验证码登录
    name: "SmallShopVerifyLoginSmallShop",
    meta: {
      navBarFlag: false,
      requiredAuth: false,
      title: "验证码登录",
    },
    component: () => import("@pages/smallShop/verifyLogin"),
  },
  {
    path: "/smallShop/verify", // 小店验证码确认页
    name: "SmallShopVerify",
    meta: {
      navBarFlag: false,
      requiredAuth: false,
      title: "输入验证码",
    },
    component: () => import("@pages/smallShop/verify"),
  },
  {
    path: "/smallShop/resetPwd", // 小店重置密码
    name: "SmallShopResetPwd",
    meta: {
      navBarFlag: false,
      requiredAuth: false,
      title: "重置密码",
    },
    component: () => import("@pages/smallShop/resetPwd"),
  },
  {
    path: "/smallShop/setPwd", // 小店设置密码
    name: "SmallShopSetPwd",
    meta: {
      navBarFlag: false,
      requiredAuth: false,
      title: "设置密码",
    },
    component: () => import("@pages/smallShop/setPwd"),
  },
  {
    path: "/smallShop/initPage", // 小店初始化页面
    name: "SmallShopInitPage",
    meta: {
      navBarFlag: false,
      requiredAuth: false,
      title: "初始化页面",
    },
    component: () => import("@pages/smallShop/initPage"),
    props: true,
  },
  {
    path: "/smallShop/register", // 小店注册页面
    name: "SmallShopRegister",
    meta: {
      navBarFlag: false,
      requiredAuth: false,
      title: "入驻小店",
    },
    component: () => import("@pages/smallShop/register"),
  },
];
